/**
 * @file Created on Wed Aug 22 2018
 * @author SKu
 */
import ConfirmBoxWithLoading from './ConfirmBoxWithLoading';
export default ConfirmBoxWithLoading;